<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === stripeEventFilterKey.Processed) {
      <mat-selection-list [formField]="formTree.processed">
        @for (processed of processedValues; track $index) {
          <mat-list-option [value]="processed" (click)="$event.stopPropagation()">
            {{ processed === 'true' ? 'Oui' : 'Non' }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === stripeEventFilterKey.Type) {
      <mat-selection-list [formField]="formTree.type">
        @for (type of typeValues; track $index) {
          <mat-list-option [value]="type" (click)="$event.stopPropagation()">
            {{ type }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
